import React from 'react';
import styled from 'styled-components';
import Button from '../../../../../../../FlyfishComponents/Button';

import { Tooltip } from '@mui/material';

const JPDiv = styled.div`
	cursor: pointer;
	min-width: 318px;
	max-width: 318px;
	border: 1px solid #7070702e;
	border-radius: 11px;
	& > .job-details {
		padding: 22px;
		& .title {
		}
		& > div {
			display: flex;
			gap: 10px;
			& > div {
				& > p:not(.title) {
					font-weight: 600;

					margin-bottom: 15px;
				}
			}
		}
		& > .custom-button {
			& > button {
				background: #ffb100 !important;
				border-radius: 18px !important;
				& > div {
					color: black !important;
				}
			}
		}
		& p {
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: normal;
			max-width: 278px;
		}
	}
`;
const JPHeading = styled.div<{ index: number }>`
	border-bottom: 1px solid #7070702e;
	min-height: 107px;
	padding: 20px;
	background: ${(props) =>
		props.index === 0
			? 'transparent linear-gradient(106deg, #efefef2E 0%, #ff4d842E 100%)'
			: props.index === 1
			? 'transparent linear-gradient(280deg, #B046F22E 0%, #EDEDED2E 100%)'
			: 'transparent linear-gradient(108deg, #F0F0F02E 0%, #B0E38A2E 100%)'};
	& > p {
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: normal;
		font-weight: 600;
		max-width: 278px;
	}
`;
type Props = {
	heading: string;
	index: number;
	jobReqId: string;
	postingDate: string;
	timeType: string;
	redirectURL: string;
	location: string;
};
const JobPostings = ({
	index,
	jobReqId,
	postingDate,
	timeType,
	heading,
	redirectURL,
	location,
}: Props) => {
	return (
		<JPDiv onClick={() => window.open(redirectURL)}>
			<JPHeading index={index} className='heading'>
				<Tooltip title={heading}>
					<p className='ff-chatbot-h5'>{heading}</p>
				</Tooltip>
			</JPHeading>
			<div className='job-details'>
				<div>
					<div>
						<p className='title ff-chatbot-body1'>Job Requisition ID</p>
						<Tooltip title={jobReqId}>
							<p className='ff-chatbot-body1'>{jobReqId}</p>
						</Tooltip>

						<p className='title ff-chatbot-body1'>Location</p>
						<Tooltip title={location}>
							<p className='ff-chatbot-body1'>{location}</p>
						</Tooltip>
					</div>
					<div>
						<p className='title ff-chatbot-body1'>Posting Date</p>
						<Tooltip title={postingDate}>
							<p className='ff-chatbot-body1'>{postingDate}</p>
						</Tooltip>
						<p className='title ff-chatbot-body1'>Time Type</p>
						<Tooltip title={timeType}>
							<p className='ff-chatbot-body1'>{timeType}</p>
						</Tooltip>
					</div>
				</div>
				<Button>View Job</Button>
			</div>
		</JPDiv>
	);
};

export default JobPostings;
